export default "__VITE_ASSET__DoUbZQz5__"